/* LUFFKA - "The evening" product page (sections/luffka-evening-*.liquid).

   1. Buying: finish tiles set the variant (URL, image, price, sold-out state);
      the form adds to the cart over /cart/add.js and hands the result to the
      theme's own cart drawer (renderContents), so the drawer behaves exactly
      as on every other page. Without JS the form posts normally. The second
      product under the buttons (data-lfk-pair), once added, joins the same
      request: Add to cart and Buy now become "Add both" / "Buy both".
   2. The floating buy bar shows whenever Add to cart and Buy now are not
      fully on screen, and turns dark while the page is dark. Buy now posts
      the form with return_to=/checkout (see the submit handler).
   3. Motion (GSAP + ScrollTrigger, loaded by the hero section): headline
      reveal, the pinned dimming scene with drifting wave lines, counting
      figures, the two-ways wipe, the sideways gallery. Under
      prefers-reduced-motion, or if GSAP failed to load, nothing is pinned or
      hidden: every scene shows its finished state (html.lfk-eve-static). */
(function () {
  const root = document.documentElement;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const motion = !reduce && window.gsap && window.ScrollTrigger;
  if (!motion) root.classList.add('lfk-eve-static');

  const IVORY = '#FAF6EC';
  const INK = '#2E2620';

  /* ---------- 1. buying ---------- */
  function initBuy() {
    const form = document.querySelector('[data-lfk-eve-form]');
    if (!form) return;
    const hero = document.querySelector('[data-lfk-eve-hero]');
    const image = hero && hero.querySelector('[data-lfk-eve-image]');
    const nameEl = hero && hero.querySelector('[data-lfk-eve-finish-name]');
    const radios = [...form.querySelectorAll('input[type="radio"][name="id"]')];
    const addButtons = [...document.querySelectorAll('[data-lfk-eve-add]')];
    const buyButtons = [...document.querySelectorAll('[data-lfk-eve-buy-now]')];
    const picks = [...document.querySelectorAll('[data-lfk-eve-pick]')];
    const error = form.querySelector('.lfk-eve-error');
    // The second product's chosen variant id while it is added, else null.
    const pair = { id: null };
    const BUY_LABEL = (both) => `${both ? 'Buy both' : 'Buy now'} <i class="lfk-eve-btn__arr" aria-hidden="true">&rarr;</i>`;
    function labels() {
      const radio = form.querySelector('input[name="id"]:checked');
      const available = !radio || radio.dataset.available !== 'false';
      addButtons.forEach((b) => {
        if (b.classList.contains('is-added')) return;
        b.querySelector('span').textContent = !available ? 'Sold out' : pair.id ? 'Add both' : 'Add to cart';
      });
      buyButtons.forEach((b) => {
        if (!b.classList.contains('is-going')) b.querySelector('.lfk-eve-btn__lbl').innerHTML = BUY_LABEL(!!pair.id);
      });
    }
    form.lfkPair = pair;
    form.lfkLabels = labels;

    function select(radio) {
      if (!radio) return;
      radio.checked = true;
      const ds = radio.dataset;
      if (nameEl) nameEl.textContent = ds.title;
      document.querySelectorAll('[data-lfk-eve-price]').forEach((el) => { el.textContent = ds.price; });
      if (image && ds.image) {
        image.removeAttribute('srcset');
        image.src = ds.image;
      }
      // The floating bar's thumbnail follows the finish (same, already cached file).
      const thumb = document.querySelector('[data-lfk-eve-thumb]');
      if (thumb && ds.image) {
        thumb.removeAttribute('srcset');
        thumb.src = ds.image;
      }
      const available = ds.available === 'true';
      addButtons.forEach((b) => { b.disabled = !available; });
      buyButtons.forEach((b) => { b.disabled = !available; });
      labels();
      picks.forEach((p) => p.setAttribute('aria-pressed', String(p.dataset.lfkEvePick === radio.value)));
      const url = new URL(location.href);
      url.searchParams.set('variant', radio.value);
      history.replaceState(history.state, '', url);
    }

    window.addEventListener('pageshow', (e) => {
      if (!e.persisted) return;
      delete form.dataset.going;
      buyButtons.forEach((b) => {
        b.classList.remove('is-going');
        b.removeAttribute('aria-busy');
      });
      labels();
    });

    const cartAddUrl = () => ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    const chosenId = () => Number((form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]')).value);
    const itemsToAdd = () => [{ id: chosenId(), quantity: 1 }].concat(pair.id ? [{ id: pair.id, quantity: 1 }] : []);

    radios.forEach((r) => r.addEventListener('change', () => select(r)));
    picks.forEach((p) => p.addEventListener('click', () => select(radios.find((r) => r.value === p.dataset.lfkEvePick))));

    form.addEventListener('submit', async (event) => {
      // Buy now posts the form itself (return_to=/checkout): Shopify adds the
      // finish and opens checkout. Mark it on its way and refuse a second press,
      // so a double click cannot order two lamps.
      if (event.submitter && event.submitter.hasAttribute('data-lfk-eve-buy-now')) {
        if (form.dataset.going) { event.preventDefault(); return; }
        form.dataset.going = 'true';
        buyButtons.forEach((b) => {
          b.classList.add('is-going');
          b.setAttribute('aria-busy', 'true');
          b.querySelector('.lfk-eve-btn__lbl').textContent = 'To checkout…';
        });
        if (!pair.id) return;
        // Both products: a plain form post carries only the lamp, so add both
        // over /cart/add.js, then open checkout.
        event.preventDefault();
        try {
          const res = await fetch(cartAddUrl(), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: itemsToAdd() }),
          });
          const data = await res.json();
          if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');
          location.href = '/checkout';
        } catch (e) {
          delete form.dataset.going;
          buyButtons.forEach((b) => { b.classList.remove('is-going'); b.removeAttribute('aria-busy'); });
          labels();
          if (error) { error.textContent = e.message + '. Please try again.'; error.hidden = false; }
        }
        return;
      }
      const drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.renderContents !== 'function') {
        if (!pair.id) return; // plain post to /cart/add
        // No drawer: add both, then show the cart page.
        event.preventDefault();
        fetch(cartAddUrl(), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: itemsToAdd() }) })
          .then(() => { location.href = (window.routes && window.routes.cart_url) || '/cart'; });
        return;
      }
      event.preventDefault();
      const sections = typeof drawer.getSectionsToRender === 'function' ? drawer.getSectionsToRender().map((s) => s.id) : [];
      addButtons.forEach((b) => b.setAttribute('aria-busy', 'true'));
      if (error) error.hidden = true;
      try {
        const res = await fetch(cartAddUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: itemsToAdd(), sections, sections_url: location.pathname }),
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
        addButtons.forEach((b) => {
          b.classList.add('is-added');
          b.querySelector('span').textContent = 'Added';
          setTimeout(() => { b.classList.remove('is-added'); labels(); }, 1800);
        });
      } catch (e) {
        if (error) { error.textContent = e.message + '. Please try again.'; error.hidden = false; }
      } finally {
        addButtons.forEach((b) => b.removeAttribute('aria-busy'));
      }
    });
  }

  /* Launch offer: keep the days left and the time bar true for a page that
     stays open; when the launch is over, only the price remains. */
  function initOffer() {
    document.querySelectorAll('[data-lfk-eve-ends]').forEach((o) => {
      const ends = Number(o.dataset.lfkEveEnds) * 1000;
      const start = Number(o.dataset.lfkEveStart) * 1000;
      if (!ends) return;
      const now = Date.now();
      const days = Math.ceil((ends - now) / 86400000);
      if (days < 1) {
        o.querySelectorAll('.lfk-eve-offer__later, .lfk-eve-offer__time, .lfk-eve-offer__cap').forEach((n) => { n.hidden = true; });
        o.classList.add('is-over');
        return;
      }
      const el = o.querySelector('[data-lfk-eve-days]');
      if (el) el.textContent = days === 1 ? '1 day' : `${days} days`;
      const bar = o.querySelector('.lfk-eve-offer__track i');
      if (bar && start && ends > start) bar.style.setProperty('--left', Math.min(1, Math.max(0.03, (ends - now) / (ends - start))).toFixed(3));
    });
  }

  /* The second product under the buttons: reveal once, then the "before"
     photo turns into the "after" photo (and the time rolls) while it is on
     screen. Its button adds it to the order (aria-pressed); with more than
     one variant the choice opens under it. Hidden after its last day (a
     cached page can outlive it), judged on Berlin's date. Reduced motion:
     the finished "after" photo, no reveal. */
  function initPair() {
    const el = document.querySelector('[data-lfk-pair]');
    const form = document.querySelector('[data-lfk-eve-form]');
    if (!el || !form || !form.lfkPair) return;
    const ends = el.dataset.lfkPairEnds;
    const today = new Date().toLocaleDateString('sv-SE', { timeZone: 'Europe/Berlin' });
    if (ends && today > ends) { el.hidden = true; return; }
    const toggle = el.querySelector('[data-lfk-pair-toggle]');
    const picks = [...el.querySelectorAll('[data-lfk-pair-pick]')];
    let variant = Number(el.dataset.lfkPairVariant);
    toggle.setAttribute('role', 'button');
    toggle.setAttribute('aria-pressed', 'false');
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      const on = toggle.getAttribute('aria-pressed') !== 'true';
      toggle.setAttribute('aria-pressed', String(on));
      el.classList.toggle('is-on', on);
      form.lfkPair.id = on ? variant : null;
      form.lfkLabels();
    });
    toggle.addEventListener('keydown', (e) => { if (e.key === ' ') { e.preventDefault(); toggle.click(); } });
    picks.forEach((b) => b.addEventListener('click', () => {
      variant = Number(b.dataset.lfkPairPick);
      picks.forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      if (form.lfkPair.id) form.lfkPair.id = variant;
    }));

    const swaps = !!el.querySelector('.lfk-pair__img--after');
    if (reduce) { el.classList.add('is-in', 'is-after'); return; }
    el.classList.add('is-armed');
    let timer = null;
    const cycle = () => {
      el.classList.toggle('is-after');
      timer = setTimeout(cycle, el.classList.contains('is-after') ? 5200 : 4200);
    };
    new IntersectionObserver(([e]) => {
      if (e.isIntersecting) {
        el.classList.add('is-in');
        if (swaps && !timer) timer = setTimeout(cycle, 1600); // first change after the reveal lands
      } else if (timer) { clearTimeout(timer); timer = null; }
    }, { threshold: 0.35 }).observe(el);
  }

  /* The review line under Add to cart: quotes take turns every 7s, three
     rounds, then stay. Hover or focus pauses; reduced motion shows the first. */
  function initProof() {
    const proof = document.querySelector('[data-lfk-eve-proof]');
    if (!proof || reduce) return;
    const quotes = [...proof.querySelectorAll('.lfk-eve-proof__q')];
    const by = proof.querySelector('.lfk-eve-proof__by');
    if (quotes.length < 2) return;
    let i = 0;
    let rounds = 0;
    let paused = false;
    ['mouseenter', 'focusin'].forEach((ev) => proof.addEventListener(ev, () => { paused = true; }));
    ['mouseleave', 'focusout'].forEach((ev) => proof.addEventListener(ev, () => { paused = false; }));
    const timer = setInterval(() => {
      if (paused) return;
      quotes[i].setAttribute('aria-hidden', 'true');
      i = (i + 1) % quotes.length;
      quotes[i].removeAttribute('aria-hidden');
      if (by) by.textContent = quotes[i].dataset.by || '';
      if (i === 0 && ++rounds >= 3) clearInterval(timer);
    }, 7000);
  }

  /* Clips that only play while on screen (the numbers' clip). Reduced
     motion: they stay on their first frame. */
  function initClips() {
    if (reduce) return;
    document.querySelectorAll('[data-lfk-eve-clip]').forEach((v) => {
      new IntersectionObserver(([e]) => { if (e.isIntersecting) v.play().catch(() => {}); else v.pause(); }, { threshold: 0.25 }).observe(v);
    });
  }

  /* ---------- 2. floating bar ---------- */
  function initBar() {
    const bar = document.querySelector('[data-lfk-eve-bar]');
    const buy = document.querySelector('[data-lfk-eve-ctas]') || document.querySelector('[data-lfk-eve-buy]');
    if (!bar || !buy) return;
    // A cached page can outlive the launch: drop the "Launch price" note then.
    const note = bar.querySelector('[data-lfk-eve-note-ends]');
    if (note && Number(note.dataset.lfkEveNoteEnds) * 1000 < Date.now()) note.hidden = true;
    // Shown whenever Add to cart and Buy now are not FULLY on screen: above
    // (scrolled past), below (a small phone's first screen) or cut by the
    // edge - a half-visible button does not count. So a buy button is always
    // one tap away, and never twice. Measured from the buttons' own box, and
    // rechecked on every resize: Shopify's cookie banner briefly overflows a
    // phone as it slides in, the browser zooms out for a frame, and an
    // observer-only rule could settle on that frame and leave the bar hidden.
    // html.lfk-eve-bar-on lifts the theme's back-to-top button above it.
    const check = () => {
      const r = buy.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const shown = r.top < 0 || r.bottom > vh;
      if (shown) bar.setAttribute('data-shown', 'true'); else bar.removeAttribute('data-shown');
      document.documentElement.classList.toggle('lfk-eve-bar-on', shown);
    };
    new IntersectionObserver(check, { threshold: [0, 0.99, 1] }).observe(buy);
    window.addEventListener('resize', check);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', check);
    // Its dark state is driven by the scene and figures (initMotion).
  }

  /* ---------- 3. motion ---------- */
  function waves(canvas) {
    const ctx = canvas.getContext('2d');
    let raf = 0;
    let t = 0;
    const dpr = Math.min(2, window.devicePixelRatio || 1);
    const size = () => { canvas.width = canvas.clientWidth * dpr; canvas.height = canvas.clientHeight * dpr; };
    size();
    window.addEventListener('resize', size);
    const draw = () => {
      raf = requestAnimationFrame(draw);
      const alpha = Number(getComputedStyle(canvas).opacity);
      if (alpha < 0.01) return;
      t += 0.006;
      const w = canvas.width;
      const h = canvas.height;
      ctx.clearRect(0, 0, w, h);
      ctx.lineWidth = 1.1 * dpr;
      for (let i = 0; i < 24; i++) {
        const y0 = (i / 24) * h * 1.1 - h * 0.05;
        ctx.beginPath();
        for (let x = 0; x <= w; x += 12 * dpr) {
          const y = y0 + Math.sin(x / (150 * dpr) + t * 2 + i * 0.7) * 14 * dpr + Math.sin(x / (63 * dpr) - t * 3 + i) * 6 * dpr;
          if (x) ctx.lineTo(x, y); else ctx.moveTo(x, y);
        }
        ctx.strokeStyle = `rgba(214, 230, 240, ${0.05 + 0.07 * Math.abs(Math.sin(i * 1.3 + t))})`;
        ctx.stroke();
      }
    };
    // Draw only while the canvas is near the screen.
    new IntersectionObserver(([e]) => {
      cancelAnimationFrame(raf);
      if (e.isIntersecting) draw();
    }, { rootMargin: '50% 0px' }).observe(canvas);
  }

  function initMotion() {
    const { gsap, ScrollTrigger } = window;
    gsap.registerPlugin(ScrollTrigger);

    // Headline (one line): each word rises out of its own mask.
    document.querySelectorAll('[data-lfk-eve-split]').forEach((h) => {
      const walk = (node) => {
        [...node.childNodes].forEach((n) => {
          if (n.nodeType === 3) {
            const frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach((part) => {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
              const w = document.createElement('span');
              w.className = 'lfk-eve-word';
              w.innerHTML = '<span class="lfk-eve-word__in"></span>';
              w.firstChild.textContent = part;
              frag.appendChild(w);
            });
            n.replaceWith(frag);
          } else if (n.nodeType === 1) walk(n);
        });
      };
      walk(h);
    });
    gsap.from('.lfk-eve-word__in', { yPercent: 110, duration: 1.1, ease: 'expo.out', stagger: 0.07, delay: 0.05 });
    // The photo and the rest of the buy column rise in quickly behind the
    // headline: the buttons are fully there within about a second.
    gsap.from('.lfk-eve-hero__media, .lfk-eve-hero__sub, .lfk-eve-buy > :not(.lfk-eve-buy__lead)', { y: 18, opacity: 0, duration: 0.9, ease: 'expo.out', stagger: 0.03, delay: 0.15 });

    // The dimming scene. It starts dimming while it is still coming up the
    // screen (so there is never an empty ivory stretch), then pins while the
    // three lines take turns beside the photo.
    document.querySelectorAll('[data-lfk-eve-scene]').forEach((scene) => {
      const lines = [...scene.querySelectorAll('.lfk-eve-line')];
      const steps = scene.querySelectorAll('.lfk-eve-progress i');
      const photo = scene.querySelector('.lfk-eve-scene__photo');
      const bg = scene.querySelector('.lfk-eve-scene__bg');
      const canvas = scene.querySelector('.lfk-eve-waves');
      const bar = document.querySelector('[data-lfk-eve-bar]');
      if (canvas) waves(canvas);
      if (!lines.length) return;
      // A picture per line: a line's clip replaces the photo while it is on
      // screen. A clip that does not loop starts again from its first frame
      // each time its line arrives; leaving pauses it.
      const media = [...scene.querySelectorAll('.lfk-eve-scene__media')];
      let current = 0;
      const showMedia = (k) => {
        const target = media.find((m) => Number(m.dataset.step) === k) || media.find((m) => Number(m.dataset.step) === 0);
        if (!target || target === media[current]) return;
        media.forEach((m) => {
          const on = m === target;
          m.classList.toggle('is-on', on);
          if (m.tagName !== 'VIDEO') return;
          if (on) { if (!m.loop) m.currentTime = 0; m.play().catch(() => {}); } else m.pause();
        });
        current = media.indexOf(target);
      };
      // The first line's text is revealed on the way in (its children); the
      // pinned timeline fades the line itself. Separate elements, so the two
      // timelines never fight over one opacity when the visitor jumps.
      gsap.set(lines.slice(1), { opacity: 0, y: 30 });
      gsap.set(lines[0].children, { opacity: 0, y: 30 });
      gsap.set(photo, { opacity: 0, y: 60, scale: 0.96 });
      gsap.set(bg, { opacity: 0 });

      gsap.timeline({
        defaults: { ease: 'none' },
        scrollTrigger: {
          trigger: scene, start: 'top 90%', end: 'top top', scrub: 0.4,
        },
      })
        .to(scene, { backgroundColor: INK, color: IVORY, duration: 1 }, 0)
        .to(bg, { opacity: 0.35, duration: 1 }, 0.2)
        .to(photo, { opacity: 1, y: 0, scale: 1, duration: 0.8 }, 0.2)
        .to(lines[0].children, { opacity: 1, y: 0, duration: 0.5, stagger: 0.08 }, 0.5);

      const per = 0.9;
      const tl = gsap.timeline({
        defaults: { ease: 'none' },
        scrollTrigger: {
          trigger: scene, start: 'top top', end: '+=' + Math.round((lines.length - 1) * per * 100 + 50) + '%', pin: true, scrub: 0.5,
          onUpdate: (st) => {
            const k = Math.min(lines.length - 1, Math.floor(st.progress * lines.length));
            steps.forEach((s, n) => s.classList.toggle('on', n === k));
            showMedia(k);
          },
        },
      });
      tl.to({}, { duration: 0.35 });
      lines.forEach((line, n) => {
        if (n === 0) return;
        tl.to(lines[n - 1], { opacity: 0, y: -30, duration: 0.3 })
          .to(line, { opacity: 1, y: 0, duration: 0.35 }, '<0.15');
        if (n === 1) tl.to(bg, { opacity: 0.75, duration: 0.5 }, '<').to(photo, { scale: 1.04, duration: 0.8 }, '<');
        tl.to({}, { duration: 0.35 });
      });
    });

    // Figures count up.
    document.querySelectorAll('[data-lfk-eve-count]').forEach((el) => {
      const to = Number(el.dataset.lfkEveCount);
      ScrollTrigger.create({
        trigger: el, start: 'top 82%', once: true,
        onEnter: () => gsap.fromTo(el, { textContent: 0 }, { textContent: to, duration: 1.4, ease: 'power3.out', snap: { textContent: 1 } }),
      });
    });
    gsap.utils.toArray('.lfk-eve-num').forEach((n, i) => gsap.from(n, { y: 40, opacity: 0, duration: 1, ease: 'expo.out', delay: i * 0.08, scrollTrigger: { trigger: n, start: 'top 85%' } }));
    // Voices: held like the scene. Quotes take turns (the underline draws in
    // as each arrives), then customers' photos slide in one after another
    // with the score; at the end the screen lifts to ivory for what follows.
    document.querySelectorAll('[data-lfk-eve-voices]').forEach((v) => {
      const beats = [...v.querySelectorAll('[data-lfk-eve-beat]')];
      const ticks = v.querySelectorAll('.lfk-eve-progress i');
      const photos = [...v.querySelectorAll('[data-lfk-eve-photo]')];
      const bg = v.querySelector('.lfk-eve-voices__bg');
      const canvas = v.querySelector('.lfk-eve-waves');
      if (canvas) waves(canvas);
      if (!beats.length) return;
      gsap.set(beats.slice(1), { opacity: 0, y: 26 });
      beats.forEach((b) => b.querySelectorAll('mark').forEach((m) => m.style.setProperty('--lfk-u', '0%')));
      const draw = (b) => b.querySelectorAll('mark').forEach((m) => gsap.to(m, { '--lfk-u': '100%', duration: 1.1, ease: 'expo.out', delay: 0.3 }));
      // The first quote's underline draws as the screen arrives.
      ScrollTrigger.create({ trigger: v, start: 'top 40%', once: true, onEnter: () => draw(beats[0]) });
      gsap.set(photos, { xPercent: 260, rotate: (i) => (i % 2 ? 6 : -6), opacity: 0 });

      let shown = 0;
      const tl = gsap.timeline({
        defaults: { ease: 'none' },
        scrollTrigger: {
          trigger: v, start: 'top top', end: '+=' + Math.round(beats.length * 80 + 20) + '%', pin: true, scrub: 0.5,
          onUpdate: (st) => {
            const k = Math.min(beats.length - 1, Math.floor(st.progress * 1.12 * beats.length));
            ticks.forEach((t, n) => t.classList.toggle('on', n === k));
            if (k !== shown) { shown = k; if (k > 0) draw(beats[k]); }
          },
        },
      });
      tl.to({}, { duration: 0.6 }); // the first quote arrived on the way in; let it be read
      beats.forEach((b, n) => {
        if (n === 0) return;
        tl.to(beats[n - 1], { opacity: 0, y: -26, duration: 0.3 })
          .to(b, { opacity: 1, y: 0, duration: 0.35 }, '<0.15');
        if (b.classList.contains('lfk-eve-beat--photos') && photos.length) {
          tl.to(photos, { xPercent: 0, rotate: 0, opacity: 1, duration: 0.6, stagger: 0.12, ease: 'power3.out' }, '<');
        }
        tl.to({}, { duration: 0.35 });
      });
      // Lift to ivory so the ivory section after it follows without a cut.
      tl.to(v, { backgroundColor: IVORY, color: INK, duration: 0.3 })
        .to(bg, { opacity: 0, duration: 0.3 }, '<');
    });

    // The floating bar is dark exactly while the middle of the screen is in
    // the dark stretch (scene start to the end of the figures, or of the
    // voices after them), decided in one place so a fast scroll can never
    // leave it in the wrong colour.
    const darkFrom = document.querySelector('[data-lfk-eve-scene]');
    const darkTo = document.querySelector('[data-lfk-eve-voices]') || document.querySelector('[data-lfk-eve-numbers]') || darkFrom;
    const floatBar = document.querySelector('[data-lfk-eve-bar]');
    if (darkFrom && floatBar) {
      // Read live positions each frame: a cached trigger range went stale
      // once the pinned scene added its length to the page.
      let queued = false;
      const paintBar = () => {
        queued = false;
        const mid = window.innerHeight / 2;
        const inDark = darkFrom.getBoundingClientRect().top < mid && darkTo.getBoundingClientRect().bottom > mid;
        floatBar.classList.toggle('is-dark', inDark);
      };
      window.addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(paintBar); } }, { passive: true });
      paintBar();
    }

    // Two ways: the second picture wipes over the first.
    document.querySelectorAll('[data-lfk-eve-ways]').forEach((ways) => {
      const b = ways.querySelector('[data-pic="b"]');
      const texts = ways.querySelectorAll('.lfk-eve-ways-text > div');
      gsap.set(b, { clipPath: 'inset(0 0 0 100%)' });
      gsap.set(texts[1], { opacity: 0, y: 30 });
      gsap.timeline({ defaults: { ease: 'none' }, scrollTrigger: { trigger: ways, start: 'top top', end: '+=160%', pin: true, scrub: 0.6 } })
        .to({}, { duration: 0.25 })
        .to(b, { clipPath: 'inset(0 0 0 0%)', duration: 0.7, ease: 'power2.inOut' })
        .to(texts[0], { opacity: 0, y: -30, duration: 0.3 }, '<')
        .to(texts[1], { opacity: 1, y: 0, duration: 0.35 }, '<0.3')
        .to({}, { duration: 0.25 });
    });

    // Gallery: vertical scroll moves the strip sideways.
    document.querySelectorAll('[data-lfk-eve-gallery]').forEach((g) => {
      const track = g.querySelector('[data-lfk-eve-track]');
      const distance = () => Math.max(0, track.scrollWidth - g.querySelector('.lfk-eve-gallery__viewport').clientWidth);
      if (distance() < 40) return;
      gsap.to(track, {
        x: () => -distance(), ease: 'none',
        scrollTrigger: { trigger: g, start: 'top top', end: () => '+=' + distance(), pin: true, scrub: 0.5, invalidateOnRefresh: true },
      });
    });

    // While the pinned scenes fill the screen (scene through gallery) the
    // site header slides away, like a product film; it returns after.
    const first = document.querySelector('[data-lfk-eve-scene]');
    const last = document.querySelector('[data-lfk-eve-gallery]') || document.querySelector('[data-lfk-eve-ways]') || first;
    if (first) {
      root.classList.add('lfk-eve-page');
      ScrollTrigger.create({
        trigger: first, start: 'top 1px', endTrigger: last, end: 'bottom 1px',
        onToggle: (st) => root.classList.toggle('lfk-eve-immersive', st.isActive),
      });
    }

    // Details: the photo beside them follows the topic being read.
    const photos = document.querySelectorAll('.lfk-eve-details__photo');
    if (photos.length > 1) {
      // Contiguous ranges: a topic stays current until the next one reaches
      // the reading line, so short topics never leave a gap with no photo.
      const topics = [...document.querySelectorAll('[data-lfk-eve-topic]')];
      const show = (key) => photos.forEach((ph) => ph.classList.toggle('is-on', ph.dataset.for === key));
      topics.forEach((topic, n) => {
        const next = topics[n + 1];
        ScrollTrigger.create({
          trigger: topic, start: n === 0 ? 'top bottom' : 'top 55%',
          endTrigger: next || topic, end: next ? 'top 55%' : 'bottom top',
          onToggle: (st) => { if (st.isActive) show(topic.dataset.lfkEveTopic); },
        });
      });
    }

    // Details rise in quietly.
    gsap.utils.toArray('.lfk-eve-spec, .lfk-eve-steps li, .lfk-eve-faq__item').forEach((el) => gsap.from(el, { y: 22, opacity: 0, duration: 0.9, ease: 'expo.out', scrollTrigger: { trigger: el, start: 'top 90%' } }));

    // Images load late; recompute pin lengths once they have.
    window.addEventListener('load', () => ScrollTrigger.refresh());
  }

  function init() {
    initBuy();
    initPair();
    initOffer();
    initProof();
    initClips();
    initBar();
    if (motion) initMotion();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
